/** ----------------------------------------
    Form
 ---------------------------------------- */

/**
 * The form class will handle form interactions
 */

export class Form {

    /** ----------------------------------------
        Constructor
     ---------------------------------------- */

    constructor(element) {
        this.element = element;
        this.inputElems = this.element.querySelectorAll('input, textarea');
        this.init();
    }

    /** ----------------------------------------
        Events
     ---------------------------------------- */
   
    setInputEvents() {
        for (let elem of this.inputElems) {
            elem.addEventListener('change', (e) => {
                this.updateInputHasValueClass(elem);
            });
        }
    }

    /** ----------------------------------------
        Input has value class
     ---------------------------------------- */

    setInputsHasValueClass() {
        for (let elem of this.inputElems) {
            this.updateInputHasValueClass(elem);
        }
    }

    updateInputHasValueClass(elem) {
        if (elem.value) {
            elem.classList.add('has-value');
        } else {
            elem.classList.remove('has-value');
        }
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    init() {
        this.setInputsHasValueClass();
        this.setInputEvents();

        if (this.formEntryEl) {
            this.setFormEntryEvent();
        }
    }

}